import Menu from '../../features/menu/Menu'
import { FC } from 'react'
import { UserApps } from '../../features/apps-list/UserApps'
import { GroupsApps } from '../../features/apps-list/GroupsApps'
import { authSlice } from '@wellesley/auth'
import { useSelector } from 'react-redux'
import { cn } from '@wellesley/ui'

interface DesktopProps {
  isVisible?: boolean
}

export const Desktop: FC<DesktopProps> = ({ isVisible = true }) => {
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)

  return (
    <div
      className={cn(
        'flex h-[100vh] flex-col items-center justify-between overflow-hidden transition-all duration-300 ease-in-out',
        isVisible ? 'w-[80px] opacity-100 2xl:w-[100px]' : 'w-0 opacity-0',
      )}
    >
      <Menu>
        <UserApps />
        {isLogged && (
          <div className="m-auto mb-1  w-9 border-b border-slate-300 pt-1"></div>
        )}
        <GroupsApps />
      </Menu>
    </div>
  )
}
